export default "/images/ardshin_bank.png?0c3dc09a48c5aadfecd994ef8294cf84";